import { render, staticRenderFns } from "./index--detail.vue?vue&type=template&id=d47a3f16&scoped=true&"
import script from "./index--detail.vue?vue&type=script&lang=js&"
export * from "./index--detail.vue?vue&type=script&lang=js&"
import style0 from "./index--detail.vue?vue&type=style&index=0&id=d47a3f16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47a3f16",
  null
  
)

export default component.exports